import { gql } from '@apollo/client';
import { pvWizardResultSection } from '../fragments/pv-wizard-result-section.gql';

export default gql`
  query PvWizardResults(
    $houseType: String
    $householdSize: String
    $roofPitch: String
    $roofAlignment: String
    $hasVehicle: String
    $vehicleType: String
    $avgMileage: String
    $daysToCharge: String
    $wantsSolarStorage: String
    $roofDetails: RoofDetailsInput
  ) {
    pvWizardResult(
      houseType: $houseType
      householdSize: $householdSize
      roofPitch: $roofPitch
      roofAlignment: $roofAlignment
      hasVehicle: $hasVehicle
      vehicleType: $vehicleType
      avgMileage: $avgMileage
      daysToCharge: $daysToCharge
      wantsSolarStorage: $wantsSolarStorage
      roofDetails: $roofDetails
    ) {
      systemCapacity {
        ...PvWizardResultSection
      }
      solarYield {
        ...PvWizardResultSection

        energyYieldsPerMonth {
          month
          monthIndex
          value
        }
      }
      sunKilometers {
        ...PvWizardResultSection
        monthlyNetzbezugAuto {
          label
          data
        }
        monthlyPvEnergieAuto {
          label
          data
        }
      }
      solarStorage {
        ...PvWizardResultSection
        monthlyNetzbezugGesamt {
          label
          data
        }
        monthlyPvEnergieGesamt {
          label
          data
        }
      }
      result {
        values {
          preisersparnis
          autarkiegrad
          sonnenkilometer
          co2einsparung
        }
        solarPartnersRequestData {
          Haustyp
          Personenanzahl
          Dachneigung
          Dachbeschaffenheit
          Baujahr
          Himmelsausrichtung
          EAutoVorhanden
          Fahrzeugtyp
          Fahrleistung
          LadestrategieLadetage
          SpeicherGewuenscht
          EurErsparnis
          Co2Ersparnis
          SonnenKmReichweite
          AbdeckungEigenbedarfInKwh
          AbdeckungEigenbedarfInProzent
        }
      }
    }
  }

  ${pvWizardResultSection}
`;
